import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_ALL_HERO_REQUEST = 'Hero/GET_ALL_HERO_REQUEST'
const GET_ALL_HERO_SUCCESS = 'Hero/GET_ALL_HERO_SUCCESS'
const GET_ALL_HERO_FAILURE = 'Hero/GET_ALL_HERO_FAILURE'

const GET_HERO_LOCATION_LIST_REQUEST = 'Hero/GET_HERO_LOCATION_LIST_REQUEST'
const GET_HERO_LOCATION_LIST_SUCCESS = 'Hero/GET_HERO_LOCATION_LIST_SUCCESS'
const GET_HERO_LOCATION_LIST_FAILURE = 'Hero/GET_HERO_LOCATION_LIST_FAILURE'

const GET_HERO_CONFIG_REQUEST = 'Hero/GET_HERO_CONFIG_REQUEST'
const GET_HERO_CONFIG_SUCCESS = 'Hero/GET_HERO_CONFIG_SUCCESS'
const GET_HERO_CONFIG_FAILURE = 'Hero/GET_HERO_CONFIG_FAILURE'

const GET_ALL_HERO_TYPE_SIZE_REQUEST = 'Hero/GET_ALL_HERO_TYPE_SIZE_REQUEST'
const GET_ALL_HERO_TYPE_SIZE_SUCCESS = 'Hero/GET_ALL_HERO_TYPE_SIZE_SUCCESS'
const GET_ALL_HERO_TYPE_SIZE_FAILURE = 'Hero/GET_ALL_HERO_TYPE_SIZE_FAILURE'

const GET_ALL_HERO_STATUS_SIZE_REQUEST = 'Hero/GET_ALL_HERO_STATUS_SIZE_REQUEST'
const GET_ALL_HERO_STATUS_SIZE_SUCCESS = 'Hero/GET_ALL_HERO_STATUS_SIZE_SUCCESS'
const GET_ALL_HERO_STATUS_SIZE_FAILURE = 'Hero/GET_ALL_HERO_STATUS_SIZE_FAILURE'

const GET_ALL_HERO_CONTRACT_REQUEST = 'Hero/GET_ALL_HERO_CONTRACT_REQUEST'
const GET_ALL_HERO_CONTRACT_SUCCESS = 'Hero/GET_ALL_HERO_CONTRACT_SUCCESS'
const GET_ALL_HERO_CONTRACT_FAILURE = 'Hero/GET_ALL_HERO_CONTRACT_FAILURE'

const GET_HERO_CONTRACT_REQUEST = 'Hero/GET_HERO_CONTRACT_REQUEST'
const GET_HERO_CONTRACT_SUCCESS = 'Hero/GET_HERO_CONTRACT_SUCCESS'
const GET_HERO_CONTRACT_FAILURE = 'Hero/GET_HERO_CONTRACT_FAILURE'

const GET_NEAR_BY_HERO_REQUEST = 'Hero/GET_NEAR_BY_HERO_REQUEST'
const GET_NEAR_BY_HERO_SUCCESS = 'Hero/GET_NEAR_BY_HERO_SUCCESS'
const GET_NEAR_BY_HERO_FAILURE = 'Hero/GET_NEAR_BY_HERO_FAILURE'

const SAVE_HERO_CONTRACT_REQUEST = 'Hero/SAVE_HERO_CONTRACT_REQUEST'
const SAVE_HERO_CONTRACT_SUCCESS = 'Hero/SAVE_HERO_CONTRACT_SUCCESS'
const SAVE_HERO_CONTRACT_FAILURE = 'Hero/SAVE_HERO_CONTRACT_FAILURE'

const SAVE_HERO_CONFIG_REQUEST = 'Hero/SAVE_HERO_CONFIG_REQUEST'
const SAVE_HERO_CONFIG_SUCCESS = 'Hero/SAVE_HERO_CONFIG_SUCCESS'
const SAVE_HERO_CONFIG_FAILURE = 'Hero/SAVE_HERO_CONFIG_FAILURE'

const SAVE_HERO_DETAIL_REQUEST = 'Hero/SAVE_HERO_DETAIL_REQUEST'
const SAVE_HERO_DETAIL_SUCCESS = 'Hero/SAVE_HERO_DETAIL_SUCCESS'
const SAVE_HERO_DETAIL_FAILURE = 'Hero/SAVE_HERO_DETAIL_FAILURE'

const SAVE_DELAY_REQUEST = 'Hero/SAVE_DELAY_REQUEST'
const SAVE_DELAY_SUCCESS = 'Hero/SAVE_DELAY_SUCCESS'
const SAVE_DELAY_FAILURE = 'Hero/SAVE_DELAY_FAILURE'

const SAVE_HERO_IMAGE_REQUEST = 'Hero/SAVE_HERO_IMAGE_REQUEST'
const SAVE_HERO_IMAGE_SUCCESS = 'Hero/SAVE_HERO_IMAGE_SUCCESS'
const SAVE_HERO_IMAGE_FAILURE = 'Hero/SAVE_HERO_IMAGE_FAILURE'

const SAVE_HERO_ID_CARD_REQUEST = 'Hero/SAVE_HERO_ID_CARD_REQUEST'
const SAVE_HERO_ID_CARD_SUCCESS = 'Hero/SAVE_HERO_ID_CARD_SUCCESS'
const SAVE_HERO_ID_CARD_FAILURE = 'Hero/SAVE_HERO_ID_CARD_FAILURE'

const SAVE_HERO_IMAGE_DOC_REQUEST = 'Hero/SAVE_HERO_IMAGE_DOC_REQUEST'
const SAVE_HERO_IMAGE_DOC_SUCCESS = 'Hero/SAVE_HERO_IMAGE_DOC_SUCCESS'
const SAVE_HERO_IMAGE_DOC_FAILURE = 'Hero/SAVE_HERO_IMAGE_DOC_FAILURE'

const DELETE_HERO_IMAGE_DOC_REQUEST = 'Hero/DELETE_HERO_IMAGE_DOC_REQUEST'
const DELETE_HERO_IMAGE_DOC_SUCCESS = 'Hero/DELETE_HERO_IMAGE_DOC_SUCCESS'
const DELETE_HERO_IMAGE_DOC_FAILURE = 'Hero/DELETE_HERO_IMAGE_DOC_FAILURE'

const SAVE_HERO_LOCATION_REQUEST = 'Hero/SAVE_HERO_LOCATION_REQUEST'
const SAVE_HERO_LOCATION_SUCCESS = 'Hero/SAVE_HERO_LOCATION_SUCCESS'
const SAVE_HERO_LOCATION_FAILURE = 'Hero/SAVE_HERO_LOCATION_FAILURE'

const SAVE_HERO_QR_CODE_REQUEST = 'Hero/SAVE_HERO_QR_CODE_REQUEST'
const SAVE_HERO_QR_CODE_SUCCESS = 'Hero/SAVE_HERO_QR_CODE_SUCCESS'
const SAVE_HERO_QR_CODE_FAILURE = 'Hero/SAVE_HERO_QR_CODE_FAILURE'

const UPDATE_HERO_PROFILE_REQUEST = 'Hero/UPDATE_HERO_PROFILE_REQUEST'
const UPDATE_HERO_PROFILE_SUCCESS = 'Hero/UPDATE_HERO_PROFILE_SUCCESS'
const UPDATE_HERO_PROFILE_FAILURE = 'Hero/UPDATE_HERO_PROFILE_FAILURE'

const UPDATE_HERO_CONFIG_REQUEST = 'Hero/UPDATE_HERO_CONFIG_REQUEST'
const UPDATE_HERO_CONFIG_SUCCESS = 'Hero/UPDATE_HERO_CONFIG_SUCCESS'
const UPDATE_HERO_CONFIG_FAILURE = 'Hero/UPDATE_HERO_CONFIG_FAILURE'

const UPDATE_HERO_RADIUS_REQUEST = 'Hero/UPDATE_HERO_RADIUS_REQUEST'
const UPDATE_HERO_RADIUS_SUCCESS = 'Hero/UPDATE_HERO_RADIUS_SUCCESS'
const UPDATE_HERO_RADIUS_FAILURE = 'Hero/UPDATE_HERO_RADIUS_FAILURE'

const UPDATE_HERO_STATUS_REQUEST = 'Hero/UPDATE_HERO_STATUS_REQUEST'
const UPDATE_HERO_STATUS_SUCCESS = 'Hero/UPDATE_HERO_STATUS_SUCCESS'
const UPDATE_HERO_STATUS_FAILURE = 'Hero/UPDATE_HERO_STATUS_FAILURE'

const DELETE_HERO_REQUEST = 'Hero/DELETE_HERO_REQUEST'
const DELETE_HERO_SUCCESS = 'Hero/DELETE_HERO_SUCCESS'
const DELETE_HERO_FAILURE = 'Hero/DELETE_HERO_FAILURE'

// Initialize State
const initialState = {
  user: {},
  isLoading: true,
  heroConfigLoading: false,
  error: {},
  heroDetail: {},
  locationList: [],
  heroList: [],
  heroTypeSize: [],
  heroStatusSize: [],
  heroLogContract: [],
  heroLogContractList: [],
  heroConfigList: [],
  nearByHero: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HERO_LOCATION_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_HERO_LOCATION_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        locationList: action.payload
      }
    case GET_HERO_LOCATION_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_ALL_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_ALL_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroList: action.payload
      }
    case GET_ALL_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_ALL_HERO_TYPE_SIZE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_ALL_HERO_TYPE_SIZE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroTypeSize: action.payload
      }
    case GET_ALL_HERO_TYPE_SIZE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_ALL_HERO_STATUS_SIZE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_ALL_HERO_STATUS_SIZE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroStatusSize: action.payload
      }
    case GET_ALL_HERO_STATUS_SIZE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_HERO_CONFIG_REQUEST:
      return {
        ...state,
        heroConfigLoading: true
      }
    case GET_HERO_CONFIG_SUCCESS:
      return {
        ...state,
        heroConfigLoading: false,
        heroConfigList: action.payload
      }
    case GET_HERO_CONFIG_FAILURE:
      return {
        ...state,
        error: action.error,
        heroConfigLoading: false
      }
    case SAVE_HERO_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroDetail: action.payload
      }
    case SAVE_HERO_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_ALL_HERO_CONTRACT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_ALL_HERO_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroLogContractList: action.payload
      }
    case GET_ALL_HERO_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_HERO_CONTRACT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_HERO_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroLogContract: action.payload
      }
    case GET_HERO_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_NEAR_BY_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_NEAR_BY_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        nearByHero: action.payload
      }
    case GET_NEAR_BY_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_CONTRACT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_DELAY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_DELAY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_DELAY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_CONFIG_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_CONFIG_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_IMAGE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_IMAGE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_IMAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_ID_CARD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_ID_CARD_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_ID_CARD_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_IMAGE_DOC_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_IMAGE_DOC_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_IMAGE_DOC_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_HERO_IMAGE_DOC_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_HERO_IMAGE_DOC_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_HERO_IMAGE_DOC_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_LOCATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_LOCATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_HERO_QR_CODE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_HERO_QR_CODE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_HERO_QR_CODE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_PROFILE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_CONFIG_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_CONFIG_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_RADIUS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_RADIUS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_RADIUS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERO_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERO_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERO_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const getHeroLocationList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_HERO_LOCATION_LIST_REQUEST
      })

      const response = await API.get(EndPoints.MAP + `/searchHero`)

      if (response.status === 200) {
        dispatch({
          type: GET_HERO_LOCATION_LIST_SUCCESS,
          payload: response.data
        })
      }
    } catch (err) {
      dispatch({
        type: GET_HERO_LOCATION_LIST_FAILURE
      })
    }
  }
}

export const getAllHeroes = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_HERO_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/search`, {
        params: options
      })
      dispatch({
        type: GET_ALL_HERO_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_ALL_HERO_FAILURE
      })
    }
  }
}

export const getHeroConfigs = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_HERO_CONFIG_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/hero-config`)
      dispatch({
        type: GET_HERO_CONFIG_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_HERO_CONFIG_FAILURE
      })
    }
  }
}

export const getHeroTypeSize = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_HERO_TYPE_SIZE_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/heroTypeSize`, {
        params: options
      })
      dispatch({
        type: GET_ALL_HERO_TYPE_SIZE_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_ALL_HERO_TYPE_SIZE_FAILURE
      })
    }
  }
}

export const getHeroStatusSize = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_HERO_STATUS_SIZE_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/heroStatusSize`,{
        params: options
      })
      dispatch({
        type: GET_ALL_HERO_STATUS_SIZE_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_ALL_HERO_STATUS_SIZE_FAILURE
      })
    }
  }
}

export const getHeroDetail = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_DETAIL_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/detail/${id}`)
      dispatch({
        type: SAVE_HERO_DETAIL_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: SAVE_HERO_DETAIL_FAILURE
      })
    }
  }
}
export const getAllHeroContract = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_HERO_CONTRACT_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/searchLogContract`, {
        params: options
      })
      dispatch({
        type: GET_ALL_HERO_CONTRACT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_ALL_HERO_CONTRACT_FAILURE
      })
    }
  }
}

export const getHeroContract = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_HERO_CONTRACT_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/logContract/${id}`)
      dispatch({
        type: GET_HERO_CONTRACT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_HERO_CONTRACT_FAILURE
      })
    }
  }
}

export const getNearByHero = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_NEAR_BY_HERO_REQUEST
      })

      const response = await API.get(EndPoints.HERO + `/nearby-hero/admin`, {
        params: options
      })

      dispatch({
        type: GET_NEAR_BY_HERO_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_NEAR_BY_HERO_FAILURE,
        payload: err.message // Added error payload
      })
    }
  }
}

export const saveHeroContract = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_DELAY_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.HERO + `/saveLogContract`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: SAVE_DELAY_SUCCESS
      })
    } catch (err) {
      dispatch({
        type: SAVE_DELAY_FAILURE
      })
    }
  }
}

export const saveConfigDelay = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_DELAY_REQUEST
      })

      await API.post(EndPoints.HERO + `/delay`, data)
      dispatch({
        type: SAVE_DELAY_SUCCESS
      })
    } catch (err) {
      dispatch({
        type: SAVE_DELAY_FAILURE
      })
    }
  }
}

export const saveHeroConfig = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_CONFIG_REQUEST
      })

      await API.post(EndPoints.HERO + `/config`, data)
      dispatch({
        type: SAVE_HERO_CONFIG_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_CONFIG_FAILURE
      })
    }
  }
}

export const saveHeroImage = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_IMAGE_REQUEST
      })

      await API.post(EndPoints.HERO + `/image-profile`, data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
      dispatch({
        type: SAVE_HERO_IMAGE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_IMAGE_FAILURE
      })
    }
  }
}

export const saveHeroIdCard = (formData, id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_ID_CARD_REQUEST
      })

      await API.post(EndPoints.HERO + `/image-idcard`, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        },
        params: {
          heroId: id
        }
      })
      dispatch({
        type: SAVE_HERO_ID_CARD_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_ID_CARD_FAILURE
      })
    }
  }
}

export const saveHeroDocument = (formData, id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_IMAGE_DOC_REQUEST
      })

      await API.post(EndPoints.HERO + `/image-document`, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        },
        params: {
          heroId: id
        }
      })
      dispatch({
        type: SAVE_HERO_IMAGE_DOC_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_IMAGE_DOC_FAILURE
      })
    }
  }
}

export const deleteHeroImage = (heroId, imageId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_HERO_IMAGE_DOC_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.HERO + `/image-document`, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: authorizationHeader
        },
        params: {
          heroId: heroId,
          imageId: imageId
        }
      })
      dispatch({
        type: DELETE_HERO_IMAGE_DOC_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_HERO_IMAGE_DOC_FAILURE
      })
    }
  }
}

export const saveHeroLocation = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_LOCATION_REQUEST
      })

      await API.post(EndPoints.HERO + `/location`, data)
      dispatch({
        type: SAVE_HERO_LOCATION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_LOCATION_FAILURE
      })
    }
  }
}

export const saveQrCodeHero = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_HERO_QR_CODE_REQUEST
      })

      await API.post(EndPoints.HERO + `/generate-qrcode`, data)
      dispatch({
        type: SAVE_HERO_QR_CODE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: SAVE_HERO_QR_CODE_FAILURE
      })
    }
  }
}

export const updateHeroProfile = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERO_PROFILE_REQUEST
      })

      await API.post(EndPoints.HERO + `/update-profile`, data)
      dispatch({
        type: UPDATE_HERO_PROFILE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERO_PROFILE_FAILURE
      })
    }
  }
}

export const updateHeroConfig = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERO_CONFIG_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HERO + `/updateHeroConfig`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_HERO_CONFIG_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERO_CONFIG_FAILURE
      })
    }
  }
}

export const updateHeroRadius = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERO_RADIUS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HERO + `/updateHeroRadius`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_HERO_RADIUS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERO_RADIUS_FAILURE
      })
    }
  }
}
export const updateHeroStatus = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERO_STATUS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HERO + `/updateHeroStatus`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_HERO_STATUS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERO_STATUS_FAILURE
      })
    }
  }
}

export const deleteHero = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_HERO_REQUEST
      })

      await API.delete(EndPoints.HERO + `/hero/${id}`)
      dispatch({
        type: DELETE_HERO_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_HERO_FAILURE
      })
    }
  }
}
